/* eslint-disable jsx-a11y/click-events-have-key-events */
import usePermissions from "hooks/usePermissions";
import { useIntl } from "react-intl";
import { useFormContext } from "react-hook-form";
import ReportType from "../../ReportType";
import REPORT_TYPES from "./ReportTypes";

interface ReportTypeSelectorProps {
  selectedReportType: ReportType;
  setSelectedReportType: (reportType: ReportType) => void;
}

/**
 * Report type selector component. Renders a list of report types to select from. The selected report type is highlighted.
 */
function ReportTypeSelector({ selectedReportType, setSelectedReportType }: ReportTypeSelectorProps) {
  const { reset } = useFormContext();
  const { permissions } = usePermissions();
  const userType = permissions && JSON.parse(permissions).user_type;
  const intl = useIntl();
  const reportTypes = REPORT_TYPES(intl);

  const onReportTypeClick = (reportType: ReportType) => {
    setSelectedReportType(reportType);
    reset();
  };

  return (
    <div className="d-flex justify-content-between overflow-auto">
      {reportTypes
        .filter((reportType) => reportType.enabledForUserTypes.includes(userType))
        .map(({ type, icon, title, description }) => (
          <div
            key={type}
            onClick={() => onReportTypeClick(type)}
            className={`report-card mr-2 ${selectedReportType === type && "report-active"}`}
          >
            <div className="d-flex align-items-center">
              {icon}
              <div className="report-title ml-2">{title}</div>
            </div>
            <div className="report-description">{description}</div>
          </div>
        ))}
    </div>
  );
}

export default ReportTypeSelector;
